import clsx from 'clsx';
import React from 'react';

import { MODAL_TYPE } from '@/src/components/common/Elements/Modal/Config';
import ModalPopup from '@/src/components/common/Elements/Modal/ModalPopup/ModalPopup';

interface ConfirmTagActionModalProps {
  onClose: () => void;
  onSubmit: () => void;
  subject: string;
  bodySubject?: string;
  actionType?: 'delete' | 'update';
}

interface GetLabelsParams {
  subject: string;
  bodySubject: string;
  actionType?: 'delete' | 'update';
}

const getLabels = ({ subject, actionType }: GetLabelsParams) => {
  if (actionType === 'update') {
    return {
      title: `Update ${subject}?`,
      body: `You are about to update a tag and will be applied to associated files/folders. Do you wish to proceed?`,
    };
  }
  return {
    title: `Delete ${subject}?`,
    body: `You are about to delete a tag and will be removed to associated files/folders. Do you wish to proceed?`,
  };
};

const ConfirmTagActionModal: React.FC<ConfirmTagActionModalProps> = (props) => {
  const { onClose, onSubmit, subject, bodySubject, actionType = 'delete' } = props;

  const { body, title } = getLabels({
    subject,
    bodySubject,
    actionType,
  });

  return (
    <ModalPopup
      id={'confirmArchive-document-modal'}
      className={clsx('modal--deleteFile', 'tw-z-[99999]')}
      modalType={MODAL_TYPE.danger}
      title={title}
      onClose={onClose}
      onConfirm={onSubmit}
      confirmBtn={{ label: actionType === 'update' ? 'Update' : 'Delete' }}
      icon={null}
    >
      <p className={clsx('tw-text-cfo-black tw-m-0')}>{body}</p>
    </ModalPopup>
  );
};

export default ConfirmTagActionModal;
